import React, { useEffect } from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { MinimumBalanceField } from "../MinimumBalanceField/MinimumBalanceField";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { WALLET_SETTING_KEYS } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletSettings } from "../../utils/useWalletSettings";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";

export const MinimumBalanceToggle = ({ subSectionKey }) => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[subSectionKey] || {};
  const { value } = subSectionConfig;
  const minBalanceToggle = useWalletStore((state) => state.minBalanceToggle);
  const setMinBalanceToggle = useWalletStore(
    (state) => state.setMinBalanceToggle
  );
  const setMinBalanceValue = useWalletStore(
    (state) => state.setMinBalanceValue
  );

  const { handleSettingsSectionValueChange } = useWalletSettings();
  const { refreshWalletBalance } = useWallets({
    isFetchWalletBalanceEnabled: true,
  });

  const handleToggleChange = () => {
    setMinBalanceToggle(!minBalanceToggle);
    if (minBalanceToggle) {
      handleSettingsSectionValueChange(WALLET_SETTING_KEYS.WALLET_CONFIG, {
        [WALLET_SETTING_KEYS.MIN_BALANCE_LIMIT]: 0,
      });
      refreshWalletBalance();
    }
  };

  // Hydrate state from user data on load
  useEffect(() => {
    const minLimitValue = value?.[WALLET_SETTING_KEYS.MIN_BALANCE_LIMIT];
    setMinBalanceToggle(!!minLimitValue);
    setMinBalanceValue(minLimitValue ? minLimitValue : 0);
  }, []);

  return (
    <div className="tw-flex tw-items-center tw-gap-[60px]">
      <SectionUnlockingSwitch
        value={minBalanceToggle}
        onChange={handleToggleChange}
      />
      {minBalanceToggle && (
        <span className="tw-flex tw-justify-center tw-items-center">
          <MinimumBalanceField isDebounce />
        </span>
      )}
    </div>
  );
};
